module.exports = __webpack_public_path__ + "img/erreur_envoie_donnee_enfant.04a50b69.png";